import { render } from "./lists.vue?vue&type=template&id=1fc20bf5"
const script = {}
script.render = render

export default script